<template>
  <router-view/>
</template>

<script>
export default {
}
</script>

<style lang="scss">
#app {
  overflow: hidden;
}

// transitions
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0 !important;
}
</style>
